import React from 'react';

import {fetchEventConnections} from '../../data/fetch';
import {useStoredDataChanged} from './useStoredDataChanged';
import Loader from './Loader';

const LoadEventConnections = ({eventId, children, skipSpinner = false}) => {
    useStoredDataChanged();
    return (
        <Loader skipSpinner={state => skipSpinner || state.events[eventId]?.connections.loaded} promises={[fetchEventConnections(eventId)]}>
            {children}
        </Loader>
    );
};

export default LoadEventConnections;
